require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-a-near-scam-criticisms-of-the-payment-card-industry-data-security-standard.json") })
        }
      }, "path---blog-a-near-scam-criticisms-of-the-payment-card-industry-data-security-standard");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-a-near-scam-criticisms-of-the-payment-card-industry-data-security-standard!./.cache/json/blog-a-near-scam-criticisms-of-the-payment-card-industry-data-security-standard.json
// module id = 423
// module chunks = 231608221292675